import type { Id } from '@repo/backend/convex/_generated/dataModel';

/** The tag filter's "No tags" option: documents that have no tags at all. */
export const UNTAGGED = 'untagged';

/** A tag filter value: one tag (and its sub-tags), or untagged documents. */
export type TagFilter = Id<'tags'> | typeof UNTAGGED;

/** The filter as search args: `untagged` is a flag, a tag is its id. */
export const tagFilterArgs = (filter?: TagFilter) =>
  filter === UNTAGGED ? { untagged: true } : { tagId: filter };

/** The real tag a filter names, if any — e.g. to tag a note created under it. */
export const filterTagId = (filter?: TagFilter): Id<'tags'> | undefined =>
  filter === UNTAGGED ? undefined : filter;
